// import jwtDecode from 'jwt-decode';
import axios from 'axios';
import { settings as s } from '../Settings';
import React, { useEffect, useState } from 'react';
import { refresh } from '../api/apiManager';
import { logoutFunc, refreshtoken } from '../../layouts/sidebar/SideBar';
import { useNavigate } from 'react-router-dom';
import { Alert, Snackbar } from '@mui/material';
class AuthService {
	// setAxiosInterceptors = ({ onLogout }) => {
	//   axios.interceptors.response.use(
	//     (response) => response,
	//     (error) => {
	//       if (error.response && error.response.status === 401) {
	//         this.setSession(null);

	//         if (onLogout) {
	//           onLogout();
	//         }
	//       }

	//       return Promise.reject(error);
	//     }
	//   );
	// };

	// handleAuthentication() {
	//   const accessToken = this.getAccessToken();
	//   const user = JSON.parse(this.getUser());

	//   if (!accessToken) {
	//     return;
	//   }

	//   if (user) {
	//     this.setUser(user);
	//   }

	//   if (this.isValidToken(accessToken) && accessToken) {
	//     this.setSession(accessToken);
	//   } else {
	//     this.setSession(null);
	//   }
	// }

	// loginWithEmailAndPassword = (email, password) =>
	//   new Promise((resolve, reject) => {
	//     fetch(`${s.baseUrl}${s.account.authenticate}`, {
	//       method: 'POST',
	//       headers: {
	//         'Content-Type': 'application/json',
	//         Accept: '*/*',
	//       },
	//       body: JSON.stringify({ username: email, password }),
	//     })
	//       .then((response) => response.json())
	//       .then((response) => {
	//         if (response.result.username) {
	//           this.setSession(response.result.token);
	//           this.setUser(response.result);
	//           resolve(response.result);
	//         } else {
	//           reject(response.result);
	//         }
	//       })
	//       .catch((error) => {
	//         reject(error);
	//       });
	//   });

	// loginInWithToken = () =>
	//   new Promise((resolve, reject) => {
	//     const user = JSON.parse(this.getUser());
	//     if (user) {
	//       resolve(user);
	//     } else {
	//       reject(user);
	//     }
	//   });

	// logout = () => {
	//   this.setSession(null);
	//   this.setUser(null);
	//   localStorage.sapracticeid=0;
	// };
	// checkAuth = () => {
	// 	const token = localStorage.getItem('accessToken');
	// 	const authTime = localStorage.getItem('loginTime');
	// 	if (!token || !authTime) return false;
	// 	else {
	// 		const timeNow = Math.floor(Date.now() / 1000);
	// 		return timeNow <= parseInt(authTime, 10);
	// 	}
	// };

	// isLoggedIn = () => new Promise((resolve) => {
	// 	const isAuthenticated = this.checkAuth();
	// 	resolve(isAuthenticated);
	// });

	// handleRefresh = async () => {
	// 	 ;
	// 	const refreshToken = this.getrefreshToken();
	// 	const accessToken = this.getAccessToken();
	// 	var t = localStorage.getItem('loginTime');
	// 	const expireTime = parseFloat(t) + 1800;
	// 	if (Date.now() / 1000 >= expireTime) {
	// 		logoutFunc();
	// 		useNavigate().navigate('/');
	// const model = { refresh: refreshToken };
	// const res = await refresh(model);
	// if (res?.status === 200) {
	// 	const token = res?.data?.access;
	// 	localStorage.setItem('accessToken', token);
	// 	axios.defaults.headers.common.Authorization = `Bearer ${token}`;
	// }
	// }
	// else
	// {
	//   localStorage.setItem('accessToken', accessToken);
	//   axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
	// }
	// };
	sessionTimeout = () => {};
	setSession = (accessToken, navigate) => {
		if (accessToken) {
			localStorage.setItem('accessToken', accessToken);
			axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
			localStorage.setItem('loginTime', Date.now() / 1000);
			var t = Date.now() / 1000;
			const expireTime = parseFloat(t) + 1680; // 28 minutes
			this.sessionTimeout = setTimeout(
				() => {
					const resp = refreshtoken();
					resp.then((res) => {
						if (res?.status === 200) {
							const token = res?.data?.access;
							localStorage.setItem('accessToken', token);
							axios.defaults.headers.common.Authorization = `Bearer ${token}`;
						} else {
							logoutFunc();
							navigate('/');
							window.alert('Your session has been expired');
						}
					});
				},
				(expireTime - t) * 1000
			); // 30 min from now
		}
	};
	setUser = (user) => {
		if (user) {
			localStorage.setItem('user', JSON.stringify(user));
			axios.defaults.headers.common.Authorization = `Bearer ${user}`;
		} else {
			localStorage.removeItem('user');
			delete axios.defaults.headers.common.Authorization;
		}
	};
	setrefreshToken = (token) => {
		localStorage.setItem('refreshtoken', token);
	};
	setaccessToken = (token) => {
		localStorage.setItem('accessToken', token);
	};
	getrefreshToken = () => localStorage.getItem('refreshtoken');
	getAccessToken = () => localStorage.getItem('accessToken');

	getUser = () => localStorage.getItem('user');

	isValidToken = (accessToken) => {
		if (!accessToken) {
			return false;
		}

		// const decoded = jwtDecode(accessToken);
		const currentTime = Date.now() / 1000;
		// return decoded.exp > currentTime;
	};

	isAuthenticated = () => !!this.getAccessToken();
}

const authService = new AuthService();
export default authService;
